'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Store = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.connect = connect;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _doohUtils = require('dooh-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function heartbeatState(state) {
  if (state.toJS != null) state = state.toJS();
  (0, _doohUtils.setHeartbeatState)({ state: state });
}

var storeShape = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  unsubscribe: _react.PropTypes.func.isRequired,
  update: _react.PropTypes.func.isRequired,
  getState: _react.PropTypes.func.isRequired
});

var Store = exports.Store = function () {
  function Store(initState) {
    var _this = this;

    _classCallCheck(this, Store);

    this.update = function (f) {
      var prevScreen = _this.state.screen;
      _this.state = f(_this.state);
      var nextScreen = _this.state.screen;
      if (nextScreen != null && prevScreen !== nextScreen && window.track) {
        var payload = { screen: nextScreen };
        if (_this.state.session) payload.session = _this.state.session;
        window.track('screen', payload, true);
      }
      heartbeatState(_this.state);
      _this.subscribers.forEach(function (e) {
        e.setState(_this.state);
      });
    };

    this.state = initState;
    heartbeatState(initState);
    this.subscribers = [];
  }

  _createClass(Store, [{
    key: 'subscribe',
    value: function subscribe(element) {
      this.subscribers.push(element);
      element.setState(this.state);
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(element) {
      var i = this.subscribers.indexOf(element);
      if (i !== -1) {
        this.subscribers.splice(i, 1);
      }
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this.state;
    }
  }]);

  return Store;
}();

var Provider = exports.Provider = function (_Component) {
  _inherits(Provider, _Component);

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { store: this.store };
    }
  }]);

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this2 = _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));

    _this2.store = props.store;
    return _this2;
  }

  _createClass(Provider, [{
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return Provider;
}(_react.Component);

Provider.propTypes = {
  store: storeShape.isRequired,
  children: _react.PropTypes.element.isRequired
};

Provider.childContextTypes = {
  store: storeShape.isRequired
};

Provider.displayName = 'Provider';

var defaultConnectOptions = {
  stateToProps: function stateToProps(s) {
    return s;
  }
};

function connect(Component) {
  var _class, _temp;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConnectOptions;

  return _temp = _class = function (_Component2) {
    _inherits(StateWrapper, _Component2);

    function StateWrapper(props, context) {
      _classCallCheck(this, StateWrapper);

      var _this3 = _possibleConstructorReturn(this, (StateWrapper.__proto__ || Object.getPrototypeOf(StateWrapper)).call(this, props, context));

      _this3.store = context.store;
      _this3.state = context.store.getState();
      return _this3;
    }

    _createClass(StateWrapper, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.store.subscribe(this);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.store.unsubscribe(this);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, this.state, {
          update: this.store.update
        }));
      }
    }]);

    return StateWrapper;
  }(Component), _class.contextTypes = {
    store: storeShape.isRequired
  }, _temp;
}


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/state.js
// module id = 63
// module chunks = 0